function querySelectorAll(selector: string, parent: Document | Element = document): NodeListOf<Element> {
    return parent.querySelectorAll(selector);
}

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        findAll(selector: string): NodeListOf<Element>;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.findAll = function (selector: string): NodeListOf<Element> {
    return querySelectorAll(selector, this);
};

// ----------------------------------------------------------------------------

export default querySelectorAll;
